const filterConfig = {
  type: 'object',
  properties: {
      description: {
          type: 'string',
      },
      subject_type: {
          type: 'string',
      },
      role: {
          type: 'string',
      },
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;
